module.exports = __webpack_public_path__ + "img/7fa796ae3f94ff8d8f6a01de5334d865.png";